import React, { useState, useRef } from "react";
import { getToken } from "../../../request";
import axios from "axios";
import { InputBox, Form, notification, Table } from "../../../components/Elements/appUtils";
import { useNavigate } from "react-router-dom";
import { fetchFrequencyDetails } from "./action";
import { addFrequencyUrl } from "./api";

import PageHeader from "../../../components/Elements/pageHeader";

function AddFrequency(props) {

  const navigate = useNavigate();
  
 let {onClose}=props;
 console.log(onClose, "onClose");
  let tableRef = useRef();
  const [formData, setFormData] = useState({
    frequency: "",
  });
  let [frequencyId, setFrequencyId] = useState("");

  const handleChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  };

  const handleS = async (e) => {
    e.preventDefault();
    formData.frequencyId = frequencyId;
 
    const response = await axios.post(addFrequencyUrl(), formData, getToken());
    if (response.data.success) {
     
      notification.success({
        message: response.data.message || "Success",
      });
      setFormData({ frequency: "" });
      tableRef.current.reload();
    
    } else {
      console.log(response.data.message,"brand data");
      notification.error({message:response.data.message});
    }
  };

  const apiRequest = (params) => {
    return new Promise(async (resolve) => {
      const data = await fetchFrequencyDetails({...params});
      console.log(data, "sddsfds")
      resolve(data)
    });
  };


  const columns = [
    {
      title: "Frequency/Routine",
      dataIndex: "frequency",
      key: "frequency",
    },
   
    {
      title: "Action",
      dataIndex: "action",
      width: 190,
      render: (val, record) => {
        return (
            <>
                <a onClick={() => {
                  navigate(`/edit-frequency?_id=${record._id}`)
                }}>
                  <img src={"./edit.svg"}/>

                </a> 
              

            </>
        );
      }
  }
  ];



  return (
    <PageHeader>
      <Form>
        <div class="card">
          <div class="card-body">
            <div class="form-elements-wrapper">
              <div class="row">
                <div class="col-lg-6">
                  <InputBox title={"Add Frequency"}>
                    <input
                      type="text"
                      className={"form-control"}
                      placeholder="Enter Frequency"
                      value={formData.frequency}
                      onChange={(e) => handleChange(e, "frequency")}
                      name="frequency"
                      required
                    />
                  </InputBox>
                </div>
              </div>
            </div>
            <button onClick={handleS} className="btn btn-success">
              SUBMIT DETAILS
            </button>
          </div>
        </div>
      </Form>
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <Table apiRequest={apiRequest} columns={columns} ref={tableRef} />
            </div>
          </div>
        </div>
      </div>
    </PageHeader>
  );
}

export default AddFrequency;
